import { Link } from "react-router-dom";

export default function Hero() {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="relative w-full h-[80vh] bg-cover bg-center"
      style={{ backgroundImage: "url('/banner.png')" }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/60 via-white/30 to-transparent"></div>

      <div className="relative z-10 h-full flex items-center px-10 md:px-20 max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            Electrical Services
            <br />
            & <span className="text-orange-500">MEP Solutions</span>
          </h1>

          <p className="mt-6 text-lg text-gray-700 font-medium">
            Engineering the Future, Powering the World
          </p>

          <div className="mt-8 flex gap-4">
            <Link
              to="/projects"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-md font-medium transition-colors"
            >
              Explore Projects
            </Link>
            <button
              onClick={scrollToContact}
              className="bg-white border-2 border-gray-300 hover:border-gray-400 px-8 py-3 rounded-md font-medium transition-colors"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}